__turbopack_context__.v({
  "cardDescription": "featured-courses-module-scss-module__HiZyca__cardDescription",
  "carouselContainer": "featured-courses-module-scss-module__HiZyca__carouselContainer",
  "container": "featured-courses-module-scss-module__HiZyca__container",
  "courseInfo": "featured-courses-module-scss-module__HiZyca__courseInfo",
  "ctaButtons": "featured-courses-module-scss-module__HiZyca__ctaButtons",
  "ctaTitle": "featured-courses-module-scss-module__HiZyca__ctaTitle",
  "fusionCourses": "featured-courses-module-scss-module__HiZyca__fusionCourses",
  "fusionCoursesButtons": "featured-courses-module-scss-module__HiZyca__fusionCoursesButtons",
  "fusionCoursesDescription": "featured-courses-module-scss-module__HiZyca__fusionCoursesDescription",
  "fusionCoursesStack": "featured-courses-module-scss-module__HiZyca__fusionCoursesStack",
  "fusionCoursesText": "featured-courses-module-scss-module__HiZyca__fusionCoursesText",
  "fusionCoursesTitle": "featured-courses-module-scss-module__HiZyca__fusionCoursesTitle",
  "playButton": "featured-courses-module-scss-module__HiZyca__playButton",
  "subtitle": "featured-courses-module-scss-module__HiZyca__subtitle",
  "title": "featured-courses-module-scss-module__HiZyca__title",
  "video": "featured-courses-module-scss-module__HiZyca__video",
  "videoContainer": "featured-courses-module-scss-module__HiZyca__videoContainer",
});
